import { useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthLayout } from '../../components/auth/AuthLayout';
import { YandexAuthButton } from '../../components/auth/YandexAuthButton';
import { Button } from '../../components/ui/Button';
import { Checkbox } from '../../components/ui/Checkbox';
import { InputField } from '../../components/ui/InputField';
import { api, ApiError } from '../../lib/api';
import { VerifyCodeModal } from './VerifyCodeModal';

export function RegisterPage() {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [acceptedTerms, setAcceptedTerms] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const [challengeId, setChallengeId] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!acceptedTerms) {
      setError('Нужно принять условия и политику обработки данных.');
      return;
    }

    setSubmitting(true);
    try {
      const response = await api.register({
        full_name: fullName,
        email,
        phone: phone || undefined,
        password,
      });
      setChallengeId(response.challenge_id);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Не удалось создать аккаунт. Попробуйте ещё раз.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout
      topRight={
        <span className="text-text-secondary">
          Есть аккаунт?{' '}
          <Link to="/login" className="font-medium text-action-primary">
            Войти
          </Link>
        </span>
      }
    >
      <form onSubmit={handleSubmit} className="mx-auto flex w-full max-w-[630px] flex-col gap-6">
        <div>
          <p className="text-[10px] font-semibold tracking-wide text-ai-accent">
            ШАГ 1 ИЗ 2 · ПРОФИЛЬ
          </p>
          <h1 className="mt-3 text-[28px] font-semibold text-text-primary">Создание аккаунта</h1>
          <p className="mt-2 text-[13px] text-text-secondary">
            Заполните профиль — рабочее пространство выберем следующим шагом.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-x-6 gap-y-4">
          <InputField
            label="ФИО"
            placeholder="Алексей Крылов"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            required
          />
          <InputField
            label="Рабочая почта"
            type="email"
            placeholder="a.krylov@company.ru"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <InputField
            label="Телефон"
            type="tel"
            placeholder="+7 999 000-00-00"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <InputField
            label="Пароль"
            type="password"
            placeholder="Не менее 10 символов"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            minLength={10}
            required
          />
        </div>

        <Checkbox
          label="Я принимаю условия и политику обработки данных"
          checked={acceptedTerms}
          onChange={(e) => setAcceptedTerms(e.target.checked)}
        />

        {error && <p className="text-xs font-medium text-status-warning">{error}</p>}

        <Button type="submit" className="w-full" disabled={submitting}>
          {submitting ? 'Создаём аккаунт…' : 'Продолжить'}
        </Button>

        {!challengeId && (
          <>
            <p className="text-center text-[11px] text-text-secondary">── или ──</p>
            <YandexAuthButton />
          </>
        )}

        <div className="rounded-xl bg-bg-surface-secondary p-4">
          <p className="text-[11px] font-semibold text-action-primary">i Требования к паролю</p>
          <p className="mt-1 text-[11px] leading-relaxed text-text-secondary">
            Минимум 10 символов, одна заглавная буква, цифра и специальный знак.
          </p>
        </div>

        <p className="text-[10px] text-text-secondary">
          Продолжая, вы подтверждаете согласие с правилами вашей организации.
        </p>
      </form>

      {challengeId && (
        <VerifyCodeModal
          open={challengeId !== null}
          onClose={() => setChallengeId(null)}
          email={email}
          challengeId={challengeId}
        />
      )}
    </AuthLayout>
  );
}
